import { navMenu } from "../../data/constants";
import Logo from "../Logo/Logo";
import Menu from "../Navigation/Menu";
import MobileMenu from "../Navigation/MobileMenu";

const Header = () => {
  return (
    <>
      <div className="flex items-center justify-between p-5 pt-5 pr-24 shadow-md lg:pl-24">
        <div className="flex-shrink-0">
          <Logo className="w-10 lg:h-20 lg:w-28" />
        </div>

        <div className="hidden md:block">
          <Menu navMenu={navMenu} />
        </div>
        <div className="md:hidden">
          <MobileMenu navMenu={navMenu} />
        </div>
      </div>
    </>
  );
};

export default Header;
